<address>
  @if (store().name) {
  <div>{{ store().name }}</div>
  } @if (store().address) {
  <div>{{ store().address }}</div>
  } @if (store().postalCode || store().city) {
  <div>{{ store().postalCode }} {{ store().city }}</div>
  } @if (store().country) {
  <div>{{ store().country }}</div>
  } @if (store().phone) {
  <div>
    <fa-icon [icon]="['fas', 'phone']" class="pr-1" />
    <a href="tel:{{ store().phone }}">{{ store().phone }}</a>
  </div>
  } @if (store().fax) {
  <div>
    <fa-icon [icon]="['fas', 'fax']" class="pr-1" />
    <span>{{ store().fax }}</span>
  </div>
  } @if (store().email) {
  <div>
    <fa-icon [icon]="['fas', 'envelope']" class="pr-1" />
    <a href="mailto:{{ store().email }}">{{ store().email }}</a>
  </div>
  }
</address>
